<template>
  <div>
    <el-form-item v-if="isShowCreativeGroupName" label="创意组名称" prop="groupName">
      <el-input v-model="creativeForm.groupName" placeholder="请输入文案（1-20个字）"></el-input>
    </el-form-item>

    <el-form-item label="创意名称" prop="dynamic_creative_name">
      <el-input v-model="creativeForm.dynamic_creative_name" placeholder="请输入创意名称（1-100个字）"></el-input>
    </el-form-item>

    <el-form-item label="投放模式">
      <el-radio-group
        v-model="creativeForm.delivery_mode"
        :disabled="pageStates.isModify || pageStates.isDuplicate"
        @change="onDeliveryModeChange"
      >
        <el-radio-button ghost :label="DELIVERY_MODE.COMPONENT"> 组件化创意 </el-radio-button>
        <!-- 智投试玩不能选 -->
        <el-radio-button ghost :label="DELIVERY_MODE.CUSTOMIZE" :disabled="marketingSceneType.version_smart"> 自定义创意 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="创意形式匹配方式">
      <el-radio-group v-model="creativeForm.dynamic_creative_type" :disabled="pageStates.isModify || pageStates.isDuplicate">
        <el-radio-button ghost :label="DYNAMIC_CREATIVE_TYPE.PROGRAM" :disabled="creativeForm.delivery_mode === DELIVERY_MODE.CUSTOMIZE">
          自动匹配
        </el-radio-button>
        <el-radio-button ghost :label="DYNAMIC_CREATIVE_TYPE.COMMON"> 手动匹配 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="创意形式" v-if="creativeForm.dynamic_creative_type === DYNAMIC_CREATIVE_TYPE.COMMON">
      <div class="creative-template-list">
        <el-card
          v-for="item in CREATIVE_TEMPLATE_LIST"
          :key="item.id"
          :class="{
            active: creativeForm.creative_template_id === item.id,
            disabled: isCreativeTemplateDisabled
          }"
          class="creative-template-card"
          shadow="never"
          @click.native="onCreativeTemplateChange(item.id)"
        >
          {{ item.label }}
        </el-card>
      </div>
    </el-form-item>
  </div>
</template>
<script setup>
import { toRef, computed } from 'vue'

import { useGdtTemplateUtils } from '@/views/create/gdt/template/hooks/utils/index.js'
import { useGdtCreativeComputes } from '@/views/create/gdt/template/hooks/utils/creative.js'
import { DYNAMIC_CREATIVE_TYPE, DELIVERY_MODE, CREATIVE_TEMPLATE_LIST } from '@/views/create/gdt/model/creative-const.js'
import { AD_MARKETING_SCENE } from '@/views/create/gdt/model/project-const'

// eslint-disable-next-line
const props = defineProps({
  value: Object,
  planForm: Object
})
// eslint-disable-next-line
const emits = defineEmits(['input', 'creative-template-change'])

// const creativeForm = toRef(props, 'value')
const creativeForm = computed(() => props.value)
const planForm = computed(() => props.planForm)
const { pageStates } = useGdtTemplateUtils()
const { isWxGamePlayable } = useGdtCreativeComputes(creativeForm)

const isCreativeTemplateDisabled = computed(() => pageStates.value.isModify || pageStates.value.isDuplicate)

const marketingSceneType = computed(() => {
  const { ad_marketing_scene } = planForm.value
  return {
    version3: typeof ad_marketing_scene === 'undefined' || ad_marketing_scene === AD_MARKETING_SCENE.VERSION_3,
    version_smart: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART,
    version_search: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH
  }
})
/**
 * @description: 批量复制、批量修改时显示
 * @param {*} computed
 * @return {*}
 */
const isShowCreativeGroupName = computed(() => {
  if (isWxGamePlayable.value) return false
  return pageStates.value.isDuplicate || pageStates.value.isModify
})

/**
 * @description: 切换投放模式时：组件化创意->自动匹配 自定义创意->手动匹配
 * @param {*} val
 * @return {*}
 */
function onDeliveryModeChange(val) {
  const form = creativeForm.value
  form.components.wxgame_playable_page.wxgame_playable_page_switch = false
  if (val === DELIVERY_MODE.CUSTOMIZE) {
    form.dynamic_creative_type = DYNAMIC_CREATIVE_TYPE.COMMON

    // 激励浏览广告时试玩页必须开启
    // form.components.wxgame_playable_page.wxgame_playable_page_switch = true
    form.creative_template_id = 910
  }
  if (val === DELIVERY_MODE.COMPONENT) {
    form.dynamic_creative_type = DYNAMIC_CREATIVE_TYPE.PROGRAM
  }
  emits('input', { ...form })
}

function onCreativeTemplateChange(templateId) {
  console.log('templateId output: ', templateId)
  if (isCreativeTemplateDisabled.value) return
  const form = creativeForm.value
  if (form.creative_template_id === templateId) return
  form.creative_template_id = templateId
  emits('input', { ...form })
  emits('creative-template-change')
}
</script>
<style lang="scss" scoped>
.creative-template-list {
  display: flex;
  gap: 10px;
}

.creative-template-card {
  width: 188px;
  cursor: pointer;

  &.active {
    border-color: #1974ff;
    font-weight: 700;
    color: #1974ff;
  }

  &.disabled {
    cursor: not-allowed;
  }
}
</style>
